import React, { useState, useEffect, useRef } from 'react'
import { Table } from "antd";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Cookies from "js-cookie";
import Api from '../../Api';
import { useDispatch, useSelector } from 'react-redux';
import Beatloader from '../../Common/Loaders/Beatloader';
import { useFormik } from 'formik';
import ReactPaginate from 'react-paginate';
import DatePicker from "react-datepicker";
import { capitalizeFirstLetter } from '../../HelperFunctions';
import { adminMainUrl } from '../../Config';
import { getCustomerLeadStatus } from '../../Redux/action/Admin/CustomerAction';


const QueryManagementList = ({ showTabs }) => {

  const GetShipmentType = async () => {
    try {
      const data = await Api(`${adminMainUrl}/api/shipment-type/get`, "GET");
      const options = data?.data
        ?.filter((item) => item.status === true).map((item) => ({
          shipmentTypeId: item.id,
          value: item.name,
          label: item.name,
        }));
      setShipmentTypeData(options);
    } catch (error) {
      setShipmentTypeData([]);
      console.error("Error fetching data:", error);
    }
  };

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true)
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [status_id, setStatus_id] = useState('');
  const [full_name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [origin, setOrigin] = useState('');
  const [destination, setDestination] = useState('');
  const [shipmentType, setShipmentType] = useState('');
  const [shipmentVia, setShipmentVia] = useState('');
  const [pickedBY, setPickedBy] = useState('');
  const [id, setId] = useState(null)
  const [isResetting, setIsResetting] = useState(false);
  const fromDate = startDate ? formatDate(startDate) : null;
  const toDate = endDate ? formatDate(endDate) : null;
  const [count, setCount] = useState(1);
  const [shipmentTypeData, setShipmentTypeData] = useState([]);
  const [shipmentViaData, setShipmentViaData] = useState([]);
  const [RequiredServiceId, setRequiredServiceId] = useState([]);
  const [requiredServiceData, setRequiredServiceData] = useState('')






  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const GetShipmentVia = async () => {
    try {
      const data = await Api(`${adminMainUrl}/api/shipment-via/get`, "GET");
      const options = data?.data
        ?.filter((item) => item.status === true).map((item) => ({
          shipmentViaId: item.id,
          value: item.name,
          label: item.name,
        }));
      setShipmentViaData(options);
    } catch (error) {
      setShipmentViaData([]);

      console.error("Error fetching data:", error);
    }
  };

  const RequiredService = async () => {
    try {
      const data = await Api(`${adminMainUrl}/api/required-service/get`, "GET");
      const options = data?.data
        ?.filter((item) => item.status === true).map((item) => ({
          RequiredServiceId: item.id,
          value: item.name,
          label: item.name,
        }));
      setRequiredServiceId(options);
    } catch (error) {
      setRequiredServiceId([]);

      console.error("Error fetching data:", error);
    }
  };

  // useEffect(() => {
  //     fetchQuotations(filterTab);
  // }, [filterTab, count]);

  useEffect(() => {
    GetShipmentType();
    GetShipmentVia();
    RequiredService()
  }, []);

  useEffect(() => {
    if (isResetting) {
      // fetchQuotations();
      setIsResetting(false);  // Reset the flag after fetching quotations
    }
  }, [isResetting]);

  const resetFields = () => {
    setSearchText('');
    setStatus_id('');
    setName('');
    setEmail('');
    setMobileNumber('');
    setOrigin('');
    setDestination('');
    setShipmentType("");
    setShipmentVia('');
    setPickedBy('');
    setRequiredServiceData('');
    // setRequiredServiceId([]);
    // setShipmentViaData([]);
    // setShipmentTypeData([]);
    setStartDate(null);
    setEndDate(null);
    setIsResetting(true);
  };


  const columns = [
    { title: "#", dataIndex: "sno", key: "sno" },
    { title: "Request No.", dataIndex: "requestNo", key: "requestNo" },
    { title: "Date", dataIndex: "date", key: "date" },
    // { title: "Name", dataIndex: "name", key: "name" },
    // { title: "Email", dataIndex: "email", key: "email" },
    // { title: "Phone Number", dataIndex: "phoneNumber", key: "phoneNumber" },
    { title: "Origin", dataIndex: "origin", key: "origin" },
    { title: "Destination", dataIndex: "destination", key: "destination" },
    { title: "Shipment Mode", dataIndex: "shipmentMode", key: "shipmentMode" },
    // { title: "Shipment Via", dataIndex: "shipmentVia", key: "shipmentVia" },
    // { title: "Picked By", dataIndex: "pickedBy", key: "pickedBy" },
    { title: "Action", dataIndex: "action", key: "action" },
  ];

  const dispatch = useDispatch();
  const location = useLocation();
  const token = Cookies.get("customertoken");
  const [query, setQuery] = useState("");
  const [pageLoader, setPageLoader] = useState(false);
  const [grid, setGrid] = useState(true)
  const [dataSourcer, setDataSourcer] = useState(false);
  const [currentPage, setCurrentPage] = useState(() => {
    const params = new URLSearchParams(location.search); // Use URLSearchParams
    const savedPage = params.get("page");
    return savedPage ? Number(savedPage) : 1;
  });
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [paginationPage, setPaginationPage] = useState(0);
  const queryParams = new URLSearchParams(location.search);
  const queryString = new URLSearchParams(location.search).toString();

  useEffect(() => {
    setQuery(queryString);
    if (queryParams.get("page")) {
      setPaginationPage(Number(queryParams.get("page") - 1))
    } else {
      setPaginationPage(0);
    }
  }, [queryParams]);


  useEffect(() => {
    dispatch(getCustomerLeadStatus(token, queryParams.get("page") ?? 1, queryString));
  }, [query]);

  let { loadingLeadStatus, leadStatusDataError, leadStatusData, leadStatusCurrentPage, leadStatusTotalPage, leadStatusTotalData, leadAllStatusCount } = useSelector(state => state?.LeadStatusReducer);


  const PickedQuotation = async (quotationId) => {
    try {
      const token = Cookies.get("token");
      const requesId = {
        quotation_id: `${quotationId}`,
      };
      const response = await fetch(`${adminMainUrl}/api/quotation/to_be_picked`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": token,
        },
        body: JSON.stringify(requesId),
      });
      const data = await response.json();
      if (!response.ok) {
        toast.error(data?.msg);
        // throw new Error(`HTTP error! status: ${response.status}`);
      }
      toast.success(data?.msg);
      // navigate('/flexichain/query-information', { state: { quotationId: quotationId } })
      // window.open(`/flexichain/query-information/${btoa(quotationId)}`)
      openNewWindow(`/flexichain/query-information/${btoa(quotationId)}`)
    } catch (error) {
      // toast.error(error);
      console.log(error);
    }
  };

  const [showDropDown, setShowDropDowm] = useState(false);


  const openNewWindow = (url) => {
    const newWindow = window.open(
      url, // URL of the new window
      '_blank', // Target window name
      'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1000,height=600' // Window features
    );

    const interval = setInterval(() => {
      if (newWindow.closed) {
        clearInterval(interval);
        refreshData();
      }
    }, 500);
  };


  useEffect(() => {
    const handleMessage = (event) => {
      // Check for a specific event type or identifier
      if (event.data === 'refreshQueryTableData') {
        refreshData();
      }
    };

    // Add event listener to the window
    window.addEventListener('message', handleMessage);
    // Cleanup listener on component unmount
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const refreshData = () => {
    if (token) {
      dispatch(getCustomerLeadStatus(token, queryParams.get("page") ?? 1, queryString));
    }
  };

  useEffect(() => {
    if (loadingLeadStatus) {
      setPageLoader(true);
    } else {
      setPageLoader(false);
    };

    if (leadStatusData) {
      let arr = leadStatusData?.map((value, i) => ({
        key: i + 1,
        sno: Number(paginationPage) * 10 + (i + 1),
        requestNo: value?.request_no,
        date: formatDate(value?.createdAt),
        // name: (
        //   <p className="d-flex align-items-center">
        //     <span to="#" className="d-flex flex-column">
        //       <span className="text-default">{value?.full_name}</span>
        //     </span>
        //   </p>
        // ),
        // email: value?.email,
        // phoneNumber: value?.phone,
        // origin: value?.origin,   
        origin: value?.origin_type == "AIRPORT" ? `${value?.origin_port_full_name} (${value?.origin_type})` : `${value?.origin_address}, ${value?.origin_city ? value?.origin_city?.name : ""}, ${value?.origin_state ? value?.origin_state?.name : ""}, ${value?.origin_country ? value?.origin_country?.name : ""} (${value?.origin_type})`,
        // destination: value?.destination,
        destination: value?.destination_type == "AIRPORT" ? `${value?.destination_port_full_name} (${value?.destination_type})` : `${value?.destination_address}, ${value?.destination_city ? value?.destination_city?.name : ""}, ${value?.destination_state ? value?.destination_state?.name : ""}, ${value?.destination_country ? value?.destination_country?.name : ""} (${value?.origin_type})`,
        shipmentMode: capitalizeFirstLetter(value?.shipment_mode),
        // shipmentVia: value?.shipment_via?.name,
        pickedBy: value?.picked_user ? `${value?.picked_user?.name}` : "-",
        action: (
          <>
            <div className="d-flex">
              <div className="dropdown table-action">
                <Link to="#" className="action-icon" data-bs-toggle="dropdown" >
                  <i className="fa fa-ellipsis-v"></i>
                </Link>
                <div className="dropdown-menu dropdown-menu-right">
                  <div className="dropdown-item" onClick={() => {
                    // if (identifiter === "all") {
                    //   PickedQuotation(value.id); // Hit the API only if filterTab is "all"
                    // } else {
                    //   openNewWindow(`/flexichain/query-information/${btoa(value?.id)}`);
                    // }
                      openNewWindow(`/customer-dashboard/query-information/${btoa(value?.id)}`);
                  }}>
                    <i className="ti ti-eye text-blue-light"></i> Preview
                  </div>
                </div>
              </div>

            </div>

          </>
        ),
      }));
      setDataSourcer(arr);
    }

    if (leadStatusTotalData) {
      setTotalItems(leadStatusTotalData);
    }

    if (leadStatusTotalPage) {
      setTotalPages(leadStatusTotalPage)
    }
  }, [loadingLeadStatus, leadStatusDataError, leadStatusData, leadStatusCurrentPage, leadStatusTotalPage, leadStatusTotalData, leadAllStatusCount]);
  //pagination
  const handlePageClick = (selectedObject) => {
    const selectedPage = selectedObject.selected + 1;
    const params = new URLSearchParams(location.search);
    setCurrentPage(selectedPage);
    params.set("page", selectedPage);
    navigate(`?${params.toString()}`);
  };

  //search and filter data
  const parseQueryParams = () => {
    const params = new URLSearchParams(location.search);
    return {
      search_by: params.get("search_by") || "",
      request_no: params.get("request_no") || "",
      name: params.get("name") || "",
      email: params.get("email") || "",
      phone: params.get("phone") || "",
      origin: params.get("origin") || "",
      destination: params.get("destination") || "",
      shipment_type_id: params.get("shipment_type_id") || "",
      shipment_via_id: params.get("shipment_via_id") || "",
      required_servie_id: params.get("required_servie_id") || "",
      start_date: params.get("start_date") || "",
      end_date: params.get("end_date") || "",
      quotation_date: params.get("quotation_date") || "",
      filter_by: params.get("filter_by") || ""
    };
  };

  let formik = useFormik({
    initialValues: parseQueryParams(),
    onSubmit: (values) => {
      const params = new URLSearchParams(location.search);
      Object.keys(values).forEach((key) => {
        if (values[key]) {
          params.set(key, values[key]);
        } else {
          params.delete(key);
        }
      });

      if (!params.has("page")) {
        params.set("page", "1");
      } else {
        params.set("page", "1");
      }
      const queryString = params.toString();
      navigate(`${location.pathname}?${queryString}`);
      const currentPage = 1;
      const ITEMS_PER_PAGE = 10;
      dispatch(getCustomerLeadStatus(token, currentPage, queryString));
    },
  });

  const resetFilters = () => {
    try {
      formik.setValues({
        search_by: "",
        request_no: "",
        name: "",
        email: "",
        phone: "",
        origin: "",
        destination: "",
        shipment_type_id: "",
        shipment_via_id: "",
        required_servie_id: "",
        start_date: "",
        end_date: "",
        quotation_date: "",
        filter_by: "",
      });
      // navigate(`/flexichain/picked-rate-request-list?page=1`);
      let url = "/customer-dashboard/query-list";
      if (url) {
        navigate(url);
      }
    } catch (error) {
      console.log(error.message);
      toast.error("Some error occured!");
    }
  };

  const handleStartDateChange = (date) => {
    if (date && date.getTime() === endDate?.getTime()) {
      alert("Start date and end date cannot be the same");
      return;
    }
    setStartDate(date);
    if (endDate && date && endDate.getTime() < date.getTime()) {
      setEndDate(null);
    }
  };

  const handleEndDateChange = (date) => {
    if (date && date.getTime() === startDate?.getTime()) {
      Swal.fire('Error', 'Start date and end date cannot be the same', 'error');
      return;
    }
    if (date && startDate && date.getTime() < startDate.getTime()) {
      Swal.fire('Error', 'End date cannot be before the start date', 'error');
      return;
    }
    setEndDate(date);
  };

  return (
    <>
      {
        pageLoader ?
          <Beatloader />
          :
          <div className="page-wrapper">
            <div className="content">
              <div className="row">
                <div className="col-md-12">
                  {/* Page Header */}
                  <div className="page-header">
                    <div className="row align-items-center">
                      <div className="col-8">
                        <h4 className="page-title">
                          Query List <span className="count-title">{leadStatusTotalData ? leadStatusTotalData : 0}</span>
                        </h4>
                      </div>
                      {/* <div className="col-4 text-end">
                        <div className="head-icons">
                          <a
                            href="javascript:void(0);"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            data-bs-original-title="Collapse"
                            id="collapse-header"
                          >
                            <i className="ti ti-chevrons-up" />
                          </a>
                        </div>
                      </div> */}
                    </div>
                  </div>
                  {/* /Page Header */}
                </div>
              </div>
              <form onSubmit={formik.handleSubmit}>
                <div className="card">
                  <div className="card-header">
                    {/* Search */}
                    <div className="row align-items-center">
                      <div className="col-sm-4">
                        <div className="icon-form mb-3 mb-sm-0">
                          <span className="form-icon">
                            <i className="ti ti-search" />
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search "
                            name='search_by'
                            value={formik.values.search_by}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          // value={searchText}
                          // onChange={(e) => setSearchText(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-sm-8">

                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                          <button type='submit' className="btn btn-primary me-2">
                            Search
                          </button>
                          <a
                            className='btn btn-primary me-2'
                            //   style={{ background: "#04aed2", marginTop: "7px", marginBottom: "15px" }}
                            onClick={() => { resetFilters() }}
                          >
                            Clear
                          </a>
                          <Link to="/customer-dashboard/add-query"
                            className='btn btn-primary me-2'
                          >
                           + Add Query
                          </Link>

                        </div>
                      </div>
                    </div>
                    {/* /Search */}
                  </div>
                  <div className="card-body">
                    {/* Filter */}
                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                      <div className="d-flex align-items-center flex-wrap row-gap-2">
                        <div className="dropdown me-2">
                          <a
                            href="javascript:void(0);"
                            className="dropdown-toggle"
                            data-bs-toggle="dropdown"
                          >
                            <i className="ti ti-sort-ascending-2 me-2" />
                            Sort{" "}
                          </a>
                          <div className="dropdown-menu  dropdown-menu-start">
                            <ul>
                              <li>
                                <a href="javascript:void(0);" className="dropdown-item">
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  Ascending
                                </a>
                              </li>
                              <li>
                                <a href="javascript:void(0);" className="dropdown-item">
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  Descending
                                </a>
                              </li>
                              <li>
                                <a href="javascript:void(0);" className="dropdown-item">
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  Recently Viewed
                                </a>
                              </li>
                              <li>
                                <a href="javascript:void(0);" className="dropdown-item">
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  Recently Added
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="icon-form">
                          <div className="input_box_section por_main_detail-date mb-0 d-sm-flex align-items-start gap-2">
                            <div className="input_box_section por_main_detail-date mb-0 custom-query-datepicker">
                              <DatePicker
                                name='start_date'
                                dateFormat="dd/MM/yy"
                                placeholderText="From"
                                selected={fromDate}
                                onChange={handleStartDateChange}
                                isClearable
                              />
                            </div>
                            <div className="input_box_section por_main_detail-date mb-0 custom-query-datepicker">
                              <DatePicker
                                name='end_date'
                                dateFormat="dd/MM/yy"
                                placeholderText="To"
                                selected={toDate}
                                onChange={handleEndDateChange}
                                isClearable
                              />
                            </div>
                          </div>

                        </div>
                      </div>
                      <div className="d-flex align-items-center flex-wrap row-gap-2">
                        <div className=" d-flex align-items-center justify-content-end">
                          <button className='btn btn-primary me-2 w-fit ' type="submit" >Search</button>
                          <div
                            className='btn btn-light me-2 w-fit'
                            onClick={() => { resetFields() }}
                          >
                            Clear
                          </div>
                        </div>
                        <div className="form-sorts dropdown me-2">
                          <a
                            href="javascript:void(0);"
                            data-bs-toggle="dropdown"
                            data-bs-auto-close="outside"
                          >
                            <i className="ti ti-filter-share" />
                            Filter
                          </a>
                          <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end p-3">
                            <div className="filter-set-view">
                              <div className="filter-set-head">
                                <h4>
                                  <i className="ti ti-filter-share" />
                                  Filter
                                </h4>
                              </div>
                              <table className="content-table">
                                <tbody>
                                  <tr>
                                    <td>
                                      <label htmlFor="#">REQUEST NO.</label>
                                    </td>
                                    <td className="input_box_filter">
                                      <input
                                        type="text"
                                        className="form-control form-control-sm ms-2"
                                        placeholder="Enter Request No."
                                        name="request_no"
                                        value={formik.values.request_no}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                      />
                                    </td>
                                  </tr>

                                  <tr>
                                    <td>
                                      <label htmlFor="#">NAME</label>
                                    </td>
                                    <td className="input_box_filter">
                                      {" "}
                                      <input
                                        type="text"
                                        className="form-control form-control-sm ms-2"
                                        placeholder="Enter Name"
                                        name="name"
                                        value={formik.values.name}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                      // value={full_name}
                                      // onChange={(e) => setName(e.target.value)}
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <label htmlFor="#">EMAIL</label>
                                    </td>
                                    <td className="input_box_filter">
                                      {" "}
                                      <input
                                        type="text"
                                        className="form-control form-control-sm ms-2"
                                        placeholder="Enter Email"
                                        name="email"
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                      // value={email}
                                      // onChange={(e) => setEmail(e.target.value)}
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <label htmlFor="#">PHONE</label>
                                    </td>
                                    <td className="input_box_filter">
                                      {" "}
                                      <input
                                        type="text"
                                        className="form-control form-control-sm ms-2"
                                        placeholder="Enter Number"
                                        name="phone"
                                        value={formik.values.phone}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                      // value={mobileNumber}
                                      // onChange={(e) => setMobileNumber(e.target.value)}
                                      />
                                    </td>
                                  </tr>
                                  {/* <tr>
                                                                        <td>
                                                                            <label htmlFor="#">ORIGIN</label>
                                                                        </td>
                                                                        <td className="input_box_filter">
                                                                            {" "}
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder="Enter Origin"
                                                                                name="origin"
                                                                                value={formik.values.origin}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                            // value={origin}
                                                                            // onChange={(e) => setOrigin(e.target.value)}
                                                                            />
                                                                        </td>
                                                                    </tr> */}
                                  {/* <tr>
                                                                        <td>
                                                                            <label htmlFor="#">DESTINATION</label>
                                                                        </td>
                                                                        <td className="input_box_filter">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder="Enter Destination"
                                                                                name="destination"
                                                                                value={formik.values.destination}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                            // value={destination}
                                                                            // onChange={(e) => setDestination(e.target.value)}
                                                                            />
                                                                        </td>
                                                                    </tr> */}
                                  {/* <tr>
                                                                        <td>
                                                                            <label htmlFor="#">SHIPMENT TYPE</label>
                                                                        </td>
                                                                        <td className="input_box_filter">

                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder="Enter Shipment Type"
                                                                                name="shipment_type_id"
                                                                                value={formik.values.shipment_type_id}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                            />
                                                                        </td>
                                                                    </tr> */}
                                  {/* <tr>
                                                                        <td>
                                                                            <label htmlFor="#">SHIPMENT VIA</label>
                                                                        </td>
                                                                        <td className="input_box_filter">
                                                                            
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder="Enter Shipment Via"
                                                                                name="shipment_via_id"
                                                                                value={formik.values.shipment_via_id}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                            />
                                                                        </td>
                                                                    </tr> */}
                                  {/* <tr>
                                                                        <td>
                                                                            <label htmlFor="#">REQUIRED SERVICE</label>
                                                                        </td>
                                                                        <td className="input_box_filter">
                                                                           
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                placeholder="Enter Required Service"
                                                                                name="required_servie_id"
                                                                                value={formik.values.required_servie_id}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                            />
                                                                        </td>
                                                                    </tr> */}
                                  {/* <tr>
                                                                    <td>
                                                                        <label htmlFor="#">PICKED BY</label>
                                                                    </td>
                                                                    <td className="input_box_filter">
                                                                        {" "}
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            placeholder="Enter Picked By"
                                                                            value={pickedBY}
                                                                            onChange={(e) => setPickedBy(e.target.value)}
                                                                        />
                                                                    </td>
                                                                </tr> */}
                                </tbody>
                              </table>

                              <div className="filter-reset-btns">
                                <div className="row">
                                  <div className="col-6">
                                    <a onClick={() => { resetFilters() }} className="btn w-100 btn-light">
                                      Reset
                                    </a>
                                  </div>
                                  <div className="col-6">
                                    <button type='submit' className="btn btn-primary w-100">
                                      Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="view-icons">
                          <Link onClick={() => { setGrid(true) }} className={`${grid === true && "active"}`}>
                            <i className="ti ti-list-tree" />
                          </Link>
                          <Link onClick={() => { setGrid(false) }} className={`${grid === false && "active"}`}>
                            <i className="ti ti-grid-dots" />
                          </Link>
                        </div>
                      </div>
                    </div>
                    {/* /Filter */}

                    {/* Contact List */}


                    {
                      grid ?

                        <div className="table-responsive custom-table">
                          <Table className="table datanew dataTable no-footer"
                            // rowSelection={rowSelection} 
                            dataSource={dataSourcer}
                            columns={columns}
                            pagination={false} />
                        </div> :
                        <div className='row'>
                          {
                            leadStatusData?.length > 0 ?
                              leadStatusData?.map((value, i) => {
                                return (
                                  <div key={i} className="col-xxl-3 col-xl-4 col-md-6">
                                    <div className="card border">
                                      <div className="card-body">
                                        <div className="d-flex align-items-center justify-content-between mb-3">
                                          <div className="d-flex align-items-center">
                                            {/* <a
                                                                                            href="#"
                                                                                            className="avatar avatar-md flex-shrink-0 me-2"
                                                                                        >
                                                                                            <img
                                                                                                src="/assets/img/profiles/avatar-19.jpg"
                                                                                                alt="img"
                                                                                            />
                                                                                        </a> */}
                                            <div>
                                              <h6>
                                                <a
                                                  href="#"
                                                  className="fw-medium"
                                                >
                                                  {value?.full_name}
                                                </a>
                                              </h6>
                                              <p className="text-default">{value?.origin_type == "AIRPORT" ? "Delhi, India" : `${value?.origin_address}, ${value?.origin_city ? value?.origin_city?.name : ""}, ${value?.origin_state ? value?.origin_state?.name : ""}, ${value?.origin_country ? value?.origin_country?.name : ""} `}</p>
                                            </div>
                                          </div>
                                          <div className="dropdown table-action">
                                            <a
                                              href="#"
                                              className="action-icon "
                                              data-bs-toggle="dropdown"
                                              aria-expanded="false"
                                            >
                                              <i className="fa fa-ellipsis-v" />
                                            </a>
                                            <div className="dropdown-menu dropdown-menu-right">

                                              <div className="dropdown-item cursor-pointer" onClick={() => {
                                                // if (identifiter === "all") {
                                                //   PickedQuotation(value.id); // Hit the API only if filterTab is "all"
                                                // } else {
                                                //   navigate('/flexichain/query-information', { state: { quotationId: value?.id } })
                                                // }
                                              }}>
                                                <i className="ti ti-eye text-blue-light"></i> Preview
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="d-block">
                                          <div className="d-flex flex-column mb-3">
                                            <p className="text-default d-inline-flex align-items-center mb-2">
                                              <i className="ti ti-mail text-dark me-1" />
                                              {value?.email}
                                            </p>
                                            <p className="text-default d-inline-flex align-items-center mb-2">
                                              <i className="ti ti-phone text-dark me-1" />
                                              {value?.phone}
                                            </p>
                                            <p className="text-default d-inline-flex align-items-center">
                                              <i className="ti ti-map-pin-pin text-dark me-1" />
                                              {value?.origin_type == "AIRPORT" ? "Mumbai, India" : `${value?.destination_address}, ${value?.destination_city ? value?.destination_city?.name : ""}, ${value?.destination_state ? value?.destination_state?.name : ""}, ${value?.destination_country ? value?.destination_country?.name : ""} `}
                                            </p>
                                          </div>
                                          <div className="d-flex align-items-center">
                                            <span className="badge badge-tag badge-success-light me-2">
                                              {value?.quote_status?.name}
                                            </span>
                                            {/* <span className="badge badge-tag badge-warning-light">
                                                                          Rated
                                                                      </span> */}
                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                )
                              }) :
                              <div className="box-grid">
                                No data available
                              </div>
                          }
                        </div>
                    }
                    <div className="row align-items-center">
                      {/* <div className="col-md-6">
                                            <div className="datatable-length" />
                                        </div>
                                        <div className="col-md-6">
                                            <div className="datatable-paginate" />
                                        </div> */}
                      {leadStatusData?.length > 0 && <div className="pagination-controls my-5 d-flex justify-content-center align-items-center react-custom-paginate">
                        <ReactPaginate
                          previousLabel={<img src="/img/right.png" alt="Previous" />}
                          nextLabel={<img src="/img/left.png" alt="Next" />}
                          breakLabel="..."
                          breakClassName="break-me"
                          pageCount={totalPages}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={5}
                          onPageChange={handlePageClick}
                          containerClassName="pagination"
                          activeClassName="active"
                          forcePage={currentPage - 1}
                        />
                      </div>
                      }
                    </div>
                  </div>
                </div>
              </form>

            </div>
          </div>
      }
    </>

  )
}

export default QueryManagementList